import React from "react";
import FeedbackContent from "./FeedbackContent";

function index() {
	return <FeedbackContent />;
}

export default index;
